// How the card listings page and order by default (#390).

/** Cards per page on every card listing. 48 fills whole rows at 2, 3 and 4 columns. */
export const CARDS_PER_PAGE = 48;

const option = (key, label, field, sort, serverOnly = false) => Object.freeze({
    key,
    label,
    field,
    sort,
    serverOnly,
    // One array per option, so a sort model keeps its identity between renders.
    model: Object.freeze([Object.freeze({ field, sort })])
});

/**
 * The orders a visitor can pick. The two `serverOnly` orders are built from restock
 * history the API holds, so a listing that sorts in the browser (My tracked products)
 * leaves them out.
 */
export const LISTING_SORT_OPTIONS = Object.freeze([
    option('inStockFirst', 'In stock first', 'inStockFirst', 'asc', true),
    option('lastRestock', 'Recently restocked', 'lastRestock', 'desc', true),
    option('priceAsc', 'Price: low to high', 'currentPrice', 'asc'),
    option('priceDesc', 'Price: high to low', 'currentPrice', 'desc'),
    option('nameAsc', 'Name: A to Z', 'name', 'asc')
]);

/** What the products page shows before anyone picks an order. */
export const DEFAULT_LISTING_SORT_MODEL = LISTING_SORT_OPTIONS[0].model;

// Links shared before the price order was renamed still say regularPrice.
const normalizeField = (field) => (field === 'regularPrice' ? 'currentPrice' : field);

/** The menu option for a field and direction, or null when the pair is not one of them. */
export const findListingSortOption = (field, sort) => (
    LISTING_SORT_OPTIONS.find((entry) => entry.field === normalizeField(field) && entry.sort === sort) || null
);
